import { useEffect, useState } from "react";
import { materialsAPI } from "../services/api";
import { useProjectContext } from "./useProjectContext";

export const useMaterials = () => {
  const { activeProject } = useProjectContext();
  const projectId = activeProject?.id;

  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    if (!projectId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await materialsAPI.listByProject(projectId);
      setMaterials(res.data || []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  const create = async (payload) => {
    if (!projectId) throw new Error("No active project selected");
    setCreating(true);
    setError(null);
    try {
      const res = await materialsAPI.create(projectId, payload);
      setMaterials((prev) => [res.data, ...prev]);
      return res.data;
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setCreating(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return { materials, loading, creating, error, reload: load, create };
};
